import { render } from "./PhaseItem.vue?vue&type=template&id=189f5332&scoped=true"
import script from "./PhaseItem.vue?vue&type=script&lang=js"
export * from "./PhaseItem.vue?vue&type=script&lang=js"

import "./PhaseItem.vue?vue&type=style&index=0&id=189f5332&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189f5332"]])

export default __exports__